import React from "react";
import { Trash2, X, Check, Clock } from "lucide-react";
import { useAuth } from "../../../../../context/AuthContext";
import SimpleButton from "../../SimpleButton";

const EventFormActions = ({
  isOriginator,
  isEditing,
  selectedEvent,
  getCurrentUserRSVPStatus,
  onDelete,
  onClose,
  onStatusUpdate,
  t,
  styles,
  handleButtonHover,
}) => {
  // ✅ Admin-level feature gating — registry "calendar.edit" / "calendar.remove".
  // Both the ownership check (isOriginator) AND the feature must pass.
  // Bypassed roles (admin/superadmin) always pass. RSVP buttons stay ungated.
  const { hasFeatureAccess } = useAuth();
  const canEdit = hasFeatureAccess("calendar", "edit");
  const canRemove = hasFeatureAccess("calendar", "remove");

  return (
    <div style={styles.formActions}>
      {isOriginator && canRemove && selectedEvent && (
        <SimpleButton icon={Trash2} variant="danger" onClick={() => onDelete(selectedEvent)}>
          {t.deleteEvent}
        </SimpleButton>
      )}

      <SimpleButton icon={X} variant="default" onClick={onClose}>
        {!isOriginator && isEditing ? t.close : t.cancel}
      </SimpleButton>

      {(!isEditing || (isOriginator && canEdit)) && (
        <SimpleButton icon={Check} variant="primary" type="submit">
          {selectedEvent ? t.updateEvent : t.createEvent}
        </SimpleButton>
      )}

      {!isOriginator &&
        isEditing &&
        !getCurrentUserRSVPStatus(selectedEvent) && (
          <>
            <SimpleButton icon={Check} variant="success" onClick={() => onStatusUpdate(selectedEvent.id, "accepted")}>
              {t.accept}
            </SimpleButton>

            <SimpleButton icon={X} variant="danger" onClick={() => onStatusUpdate(selectedEvent.id, "declined")}>
              {t.decline}
            </SimpleButton>

            <SimpleButton icon={Clock} variant="warning" onClick={() => onStatusUpdate(selectedEvent.id, "tentative")}>
              {t.maybe}
            </SimpleButton>
          </>
        )}
    </div>
  );
};

export default EventFormActions;
